import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import { draggableResource, XResource } from '../../commonComponents';
import { EDIE_BLOCK_TYPE } from '@cimpress-technology/edie-processors';
import Icon from './icon_barcode.svg';

class XBarcodeResource extends Component {
  render () {
    return draggableResource(this.props, <div>
      <XResource resourceName={'Barcode'} resourceIcon={Icon} />
    </div>);
  }
}

const source = {
  beginDrag () {
    return {
      resourceType: EDIE_BLOCK_TYPE.IMAGE,
      resourceTypeMetadata: {
        uiType: 'barcode',
        barcodeValue: '',
        barcodeType: 'CODE128'
      }
    };
  }
};

function collect (connect, monitor) {
  return {
    connectDragPreview: connect.dragPreview(),
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}

export default DragSource(EDIE_BLOCK_TYPE.IMAGE, source, collect)(XBarcodeResource);
